import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramUGCManagementListPosts.graphql';
import { Query, QueryinstagramUGCManagementListPostsArgs } from '../../__generated__/globalTypes';

export const useInstagramUGCManagementListPostsQuery = (
  options?: QueryHookOptions<Query, QueryinstagramUGCManagementListPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramUGCManagementListPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramUGCManagementListPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramUGCManagementListPostsArgs>
): QueryResult<Query, QueryinstagramUGCManagementListPostsArgs> & {
  getInstagramUGCManagementListPosts: LazyQueryExecFunction<Query, QueryinstagramUGCManagementListPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramUGCManagementListPosts, result] = useLazyQuery<Query, QueryinstagramUGCManagementListPostsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInstagramUGCManagementListPosts, ...result };
};

export const useInstagramUGCManagementListPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramUGCManagementListPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramUGCManagementListPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramUGCManagementListPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramUGCManagementListPosts };
};
// Suspense Query Hooks
export const useInstagramUGCManagementListPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramUGCManagementListPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramUGCManagementListPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
